var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather10D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xA0icon-10d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-icon-10d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-01d",
    transform: "translate(22.000000, 1.000000)",
    stroke: "#E3B505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    fill: "#F5D547",
    strokeLinecap: "square",
    cx: 18,
    cy: 18.0833333,
    rx: 9.87096774,
    ry: 9.91666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0.583333333 L18,5.25",
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7092419,0.791589884 L22.7175169,6.6220739",
    id: "Line-5",
    transform: "translate(22.713379, 3.706832) rotate(19.000000) translate(-22.713379, -3.706832) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9094702,3.08012885 L26.9225118,8.90327296",
    id: "Line-5",
    transform: "translate(26.915991, 5.991701) rotate(38.000000) translate(-26.915991, -5.991701) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1462772,6.6164599 L30.158556,12.4308855",
    id: "Line-5",
    transform: "translate(30.152417, 9.523673) rotate(57.000000) translate(-30.152417, -9.523673) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0687843,11.0159909 L32.0750944,16.8240158",
    id: "Line-5",
    transform: "translate(32.071939, 13.920003) rotate(76.000000) translate(-32.071939, -13.920003) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4677161,15.8009542 L32.4653821,21.60761",
    id: "Line-5",
    transform: "translate(32.466549, 18.704282) rotate(95.000000) translate(-32.466549, -18.704282) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.298478,20.4526089 L31.2884895,26.2635077",
    id: "Line-5",
    transform: "translate(31.293484, 23.358058) rotate(114.000000) translate(-31.293484, -23.358058) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6865673,24.4675455 L28.6731592,30.2865004",
    id: "Line-5",
    transform: "translate(28.679863, 27.377023) rotate(133.000000) translate(-28.679863, -27.377023) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9144853,27.4119546 L24.9033423,33.2393631",
    id: "Line-5",
    transform: "translate(24.908914, 30.325659) rotate(152.000000) translate(-24.908914, -30.325659) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.391353,28.9680979 L20.3871996,34.8007734",
    id: "Line-5",
    transform: "translate(20.389276, 31.884436) rotate(171.000000) translate(-20.389276, -31.884436) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.608647,28.9680979 L15.6128004,34.8007734",
    id: "Line-5",
    transform: "translate(15.610724, 31.884436) rotate(189.000000) translate(-15.610724, -31.884436) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0855147,27.4119546 L11.0966577,33.2393631",
    id: "Line-5",
    transform: "translate(11.091086, 30.325659) rotate(208.000000) translate(-11.091086, -30.325659) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31343272,24.4675455 L7.32684084,30.2865004",
    id: "Line-5",
    transform: "translate(7.320137, 27.377023) rotate(227.000000) translate(-7.320137, -27.377023) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70152197,20.4526089 L4.71151048,26.2635077",
    id: "Line-5",
    transform: "translate(4.706516, 23.358058) rotate(246.000000) translate(-4.706516, -23.358058) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53228392,15.8009542 L3.5346179,21.60761",
    id: "Line-5",
    transform: "translate(3.533451, 18.704282) rotate(265.000000) translate(-3.533451, -18.704282) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93121571,11.0159909 L3.9249056,16.8240158",
    id: "Line-5",
    transform: "translate(3.928061, 13.920003) rotate(284.000000) translate(-3.928061, -13.920003) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8537228,6.6164599 L5.84144396,12.4308855",
    id: "Line-5",
    transform: "translate(5.847583, 9.523673) rotate(303.000000) translate(-5.847583, -9.523673) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09052981,3.08012885 L9.0774882,8.90327296",
    id: "Line-5",
    transform: "translate(9.084009, 5.991701) rotate(322.000000) translate(-9.084009, -5.991701) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2907581,0.791589884 L13.2824831,6.6220739",
    id: "Line-5",
    transform: "translate(13.286621, 3.706832) rotate(341.000000) translate(-13.286621, -3.706832) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 10.000000)",
    fill: "#59A5D8",
    stroke: "#0A6EAC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0663631,22.2223732 C30.794449,23.4071259 29.0503703,24.137931 27.1262136,24.137931 C25.5546614,24.137931 24.1032352,23.6504269 22.9310743,22.8262603 C21.642276,24.1621281 19.7884458,25 17.7281553,25 C15.0942791,25 12.7978225,23.6306596 11.5879491,21.6020813 C10.4082421,22.3875973 8.9949041,22.8448276 7.47572816,22.8448276 C3.3469975,22.8448276 0,19.4676651 0,15.3017241 C0,11.4432847 2.8711278,8.26147688 6.57527241,7.81278008 C7.27570752,4.82234538 10.0905053,2.5862069 13.4563107,2.5862069 C14.7169299,2.5862069 15.9002549,2.89988816 16.9241479,3.44939565 C18.9579118,1.33236858 21.9138413,0 25.2038835,0 C30.5445253,0 35.0047732,3.51081825 36.0693131,8.18970077 C36.0785675,8.18967038 36.0878256,8.18965517 36.0970874,8.18965517 C40.4617455,8.18965517 44,11.5668176 44,15.7327586 C44,19.8986996 40.4617455,23.2758621 36.0970874,23.2758621 C34.6247813,23.2758621 33.2465098,22.8915821 32.0663631,22.2223732 Z",
    id: "Combined-Shape-Copy-3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,36 C9.65685425,36 11,34.5010632 11,32.652031 C11,31.4193428 10,29.5353325 8,27 C6,29.5353325 5,31.4193428 5,32.652031 C5,34.5010632 6.34314575,36 8,36 Z",
    id: "Oval-11",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,46 C22.6568542,46 24,44.5010632 24,42.652031 C24,41.4193428 23,39.5353325 21,37 C19,39.5353325 18,41.4193428 18,42.652031 C18,44.5010632 19.3431458,46 21,46 Z",
    id: "Oval-11-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,37 C33.6568542,37 35,35.5010632 35,33.652031 C35,32.4193428 34,30.5353325 32,28 C30,30.5353325 29,32.4193428 29,33.652031 C29,35.5010632 30.3431458,37 32,37 Z",
    id: "Oval-11-Copy-2",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather10D);
export default __webpack_public_path__ + "static/media/icon-weather-10d.1ed975788fd366030902960dc3b238f8.svg";
export { ForwardRef as ReactComponent };